export default {
  app: {
    featured: 'Fremhevet',
    random: 'Tilfeldig',
    explore: 'Alle oppskrifter',
    keywords: 'Nøkkelord',
    search: 'Søk',
  },
  explore: {
    filters: 'Filter',
    resetFilters: 'Nullstill filter',
    addKeyword: 'Legg til nøkkelord',
  },
  recipe: {
    contributedBy: 'Bidrag fra',
    ingredients: 'Ingredienser',
    directions: 'Fremgangsmåte',
    fullRecipe: 'Se hele oppskriften på',
    similarDrinks: 'Lignende drinker',
  },
  featuredRecipes: {
    loadMore: 'Last mer',
  },
  recipeFind: {
    filterBy: 'Filtrer etter',
    name: 'Navn',
    ingredients: 'Ingredienser',
    keywords: 'Nøkkelord',
    searchForIngredients: 'Du kan søke etter flere ingredienser ved å skille dem med et mellomrom',
    searchForKeywords: 'Du kan søke etter flere nøkkelord ved å skille dem med et mellomrom',
  },
  recipeList: {
    viewRecipe: 'Se oppskrift',
  },
  recipeToolbar: {
    print: 'Skriv ut',
    share: 'Del',
    shareOnFacebook: 'Del på Facebook',
    shareOnTwitter: 'Del på Twitter',
    copyURL: 'Kopier URL',
    hideImage: 'Skjul bilde',
  },
  favorites: {
    removeAllFavorites: 'Fjern alle favoritter',
    noFavoriteDrinks: 'Du har ingen favorittdrinker',
    removeFavoritesPrompt: 'Er du sikker på at du vil fjerne alle favoritter?',
    delete: 'Slett',
    cancel: 'Avbryt',
  },
  keywordList: {
    enterYourKeyword: 'Søk etter nøkkelord',
  },
  search: {
    findYourDrink: 'Finn din drink',
  },
  pageNotFound: {
    pageNotFound: 'Siden du leter etter ble ikke funnet.',
    backToHome: 'Tilbake til hjem',
  },
};
